import service from '@/services/SIRgpd_resul_eval';

export default {
  namespaced: true,

  actions: {
    /**
     * Permite obtener los parámetros de un WebApp Vue.
     */
    read({ dispatch, rootGetters }) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRgpd_resul_eval: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRgpd_resul_eval: [
              {
                picdoc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                picter_nit: rootGetters['SICUDgpd_est_crd/state'].nit,
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.dsSIRgpd_resul_eval;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              resolve(data.eegpd_resul_eval[0]);
            } else if (data?.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: 'Ocurrió un error inesperado. Por favor cierre esta pestaña e inténtelo nuevamente',
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
